module.exports = __webpack_public_path__ + "img/moneymex_scroll01.8fd33d76.webp";